import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: 'dropdown.component.html',
  styleUrls: ['dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @Input() list: any[];
  @Input() displayField: string;
  @Input() displayChildField: string;
  @Input() childListFledName: string;
  @Input() selectedItem: any;
  @Input() placeHolder: string;
  @Input() minWidth: number;
  @Output() selectedItemChange = new EventEmitter();
  isShow: boolean;

  constructor(
    private elementRef: ElementRef
  ) { }

  @HostListener('document:click', ['$event.target']) onMouseEnter(targetElement: any): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.isShow = false;
    }
  }

  ngOnInit(): void {
    if (!this.placeHolder) {
      this.placeHolder = 'All Items';
    }
  }

  getSelectedItem(item: any, isParent: boolean, isChild: boolean): void {
    if (isParent) {
      item.isParent = true;
    } else {
      item.isChild = true;
    }
    this.selectedItem = item;
    this.selectedItemChange.emit(item);
    this.isShow = false;
  }

  displaySelectedItem(): string {
    if (this.selectedItem && this.selectedItem[this.displayField]) {
      return this.selectedItem[this.displayField];
    } else if (this.selectedItem && this.selectedItem[this.displayChildField]) {
      return this.selectedItem[this.displayChildField];
    } else {
      return this.placeHolder;
    }
  }

}
